import { useState, useEffect } from "react";
import Markdown from "markdown-to-jsx";
import "../../markdown.css";
function MarkReader({ file_name }: any) {
  const [content, setContent] = useState("");

  useEffect(() => {
    fetch(file_name)
      .then((response) => response.text())
      .then((text) => setContent(text));
  }, []);
  console.log(file_name);
  return (
    <>
      <div id="blog" className={`container markdown ${file_name}  `}>
        <Markdown
          options={{
            overrides: {
              a: {
                component: "a",
                props: {
                  target: "_blank",
                  rel: "noopener noreferrer",
                },
              },
            },
          }}
        >
          {content}
          {/* {file_name} */}
        </Markdown>
      </div>
    </>
  );
}

export default MarkReader;
